import useTranslation from 'next-translate/useTranslation'
import { Button } from '@/components/Button'
import FlowText from './FlowText'

export interface RejectionViewProps {
  note: string
  onReset: () => void
}

export default function RejectionView({ note, onReset }: RejectionViewProps) {
  const { t } = useTranslation('wertCheck')

  return (
    <div className="bg-static-white rounded-xl shadow-[0_0_2rem_rgba(0,0,0,0.1)] p-6 flex flex-col items-center gap-4 text-center">
      <FlowText text={note} className="text-l text-primary" />

      <Button type="button" variant="cta" className="w-full" onClick={onReset}>
        {t('rejected_try_again')}
      </Button>
    </div>
  )
}
